import styled from "styled-components";
import ReactSlider from "react-slider";
import { colors, fonts } from "../../../styles/variables";

export const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 40px;
`;

export const StyledThumb = styled.div`
  height: 40px;
  line-height: 40px;
  width: 40px;
  text-align: center;
  background-color: ${colors.white};
  border: 1px solid ${colors.black};
  color: ${colors.black};
  cursor: grab;
  font-size: 10px;
  font-family: ${fonts.fontBauMedium};
`;

/* eslint-disable @typescript-eslint/no-explicit-any */
export const StyledTrack = styled.div<{
  index: number;
}>`
  top: ${(props: any) => (props.index === 1 ? "16px" : "20px")};
  background: ${colors.black};
  height: ${(props) => (props.index === 1 ? "8px" : "1px")};
`;
/* eslint-disable @typescript-eslint/no-explicit-any */
